import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromLayoutSelectors from '../../../store/selectors/layout.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-main-layout',
  standalone: false,
  styleUrls: ['./main-layout.component.scss'],
  templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent {
  private store = inject(Store);

  useMobileLayout$: Observable<boolean>;

  constructor() {
    this.useMobileLayout$ = this.store.pipe(select(fromLayoutSelectors.selectUseMobileLayout));
  }
}
